import { BCMOsisRuleFormData, BCMOsisRuleFormValidationData } from '../../../integrated-client/models';

export interface IRuleData {
  ruleFormData?: BCMOsisRuleFormData
  validation?: BCMOsisRuleFormValidationData
  readyToSaveRuleForm: boolean
}
export class RuleData implements IRuleData {

  ruleFormData?: BCMOsisRuleFormData
  validation?: BCMOsisRuleFormValidationData
  readyToSaveRuleForm: boolean

  constructor() {
    this.readyToSaveRuleForm = false;
  }
}